import { render, staticRenderFns } from "./submodul.vue?vue&type=template&id=0d80537c&scoped=true"
import script from "./submodul.vue?vue&type=script&lang=js"
export * from "./submodul.vue?vue&type=script&lang=js"
import style0 from "./submodul.vue?vue&type=style&index=0&id=0d80537c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80537c",
  null
  
)

export default component.exports